import { environment } from '../environments/environment';

export class ConfigService {
	public static REST_SERVER: string = '';
	public static DEFAULT_LANG: string = 'es';
	public static GOOGLE_API_KEY: string = 'AIzaSyBSdMW3q_RTgMrrtfC2KxmtzSxWehMF7kA';
	public static GOOGLE_API_VERSION: string = '3.31';
	public static DEBUG: boolean = false;
	public static MAX_PERIMETER_LENGTH_METERS: number = 6000;
	public static MAX_DOORS: number = 5;
	public static DATE_FORMAT: string = 'DD-MM-YYYY';
	//public static LANDING_AFTER_LOGIN: string = 'builder';
	static UNITY_3D_CONFIG_PATH: any;

	// LOCAL STORAGE
	public static AUTH_TOKEN = 'authToken';
	public static LANGUAGE = 'language';

	constructor() {
		//console.log('ConfigService: Detected local set REST_SERVER a ' + environment.env);
		ConfigService.REST_SERVER = environment.url;
	}
}
export const appConfig = new ConfigService();